import React from 'react';
import { motion } from 'framer-motion';

const Button = ({ children, onClick, className = '', type = 'button', size = 'lg' }) => {
  const baseStyles = "inline-flex items-center justify-center font-bold uppercase tracking-wider transition-all duration-300 focus:outline-none focus:ring-4 focus:ring-brand-yellow/50 rounded-sm";
  
  const sizes = {
    md: "px-6 py-3 text-sm",
    lg: "px-8 py-4 text-base md:text-lg w-full md:w-auto",
  };

  return (
    <motion.button
      whileHover={{ scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
      type={type}
      onClick={onClick}
      className={`${baseStyles} ${sizes[size]} bg-brand-yellow text-brand-dark hover:bg-yellow-400 shadow-[0_4px_14px_0_rgba(255,214,49,0.39)] hover:shadow-[0_6px_20px_rgba(255,214,49,0.23)] ${className}`}
    >
      {children}
    </motion.button>
  );
};

export default Button;